import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-last-reports',
  templateUrl: './last-reports.component.html',
  styleUrls: ['./last-reports.component.scss']
})
export class LastReportsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
